/* Phone buy bar (snippets/md-buy-bar.liquid). It drives the page's own variant picker and Add to bag button, so
   stock, price, the sale display and the cart drawer keep working exactly as before. */
if (!customElements.get('md-buy-bar')) {
  class MdBuyBar extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.section-main-product') || document.querySelector('.section-main-product');
      if (!this.section) return;
      try { this.variants = JSON.parse(this.querySelector('[data-md-bb-variants]').textContent); } catch (e) { return; }
      this.sizeIndex = parseInt(this.dataset.sizeIndex, 10);
      this.picked = false;
      this.chips = [...this.querySelectorAll('.md-bb__size')];
      this.addBtn = this.querySelector('.md-bb__add');
      this.msg = this.querySelector('.md-bb__msg');
      this.priceBox = this.querySelector('.md-bb__price');

      this.mq = window.matchMedia('(max-width: 767.98px)');
      this.hidden = false;
      this.onMq = () => document.body.classList.toggle('md-bb-on', this.mq.matches);
      this.mq.addEventListener('change', this.onMq);
      this.onMq();
      new ResizeObserver(() => document.body.style.setProperty('--md-bb-h', `${this.offsetHeight + 12}px`)).observe(this);

      this.chips.forEach((c) => c.addEventListener('click', () => this.pickSize(c.dataset.value)));
      this.addBtn.addEventListener('click', () => this.add());
      this.querySelector('.md-bb__guide')?.addEventListener('click', () => this.openGuide());

      // the picker announces every variant change; a shopper choosing a size in the page itself also counts as picked
      this.section.addEventListener('on:variant:change', () => this.render());
      this.section.addEventListener('change', (e) => {
        if (e.isTrusted && this.sizeFieldset()?.contains(e.target)) { this.picked = true; this.render(); }
      });
      const priceWrap = this.section.querySelector('.price-container');
      if (priceWrap) new MutationObserver(() => this.copyPrice()).observe(priceWrap, { childList: true, subtree: true, characterData: true });

      this.watchButton();
      this.render();
    }

    disconnectedCallback() {
      this.mq?.removeEventListener('change', this.onMq);
      document.body.classList.remove('md-bb-on');
      this.io?.disconnect();
    }

    sizeFieldset() {
      return this.section.querySelector(`variant-picker .option-selector[data-index="${this.sizeIndex + 1}"]`);
    }

    mainButton() {
      return this.section.querySelector('.quantity-submit-row .add-to-cart');
    }

    // the selected value of each option, read from the page's own picker
    currentOptions() {
      return [...this.section.querySelectorAll('variant-picker .option-selector')].map((fs) => {
        const checked = fs.querySelector('input:checked');
        if (checked) return checked.value;
        const select = fs.querySelector('select, input[type="hidden"]');
        return select ? select.value : null;
      });
    }

    variantFor(options) {
      return this.variants.find((v) => v.o.every((val, i) => val === options[i]));
    }

    // hide the bar while the page's own Add to bag button is on screen
    watchButton() {
      this.io?.disconnect();
      const row = this.section.querySelector('.quantity-submit-row');
      if (!row) return;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => this.classList.toggle('is-away', en.isIntersecting));
      }, { threshold: 0.6 });
      this.io.observe(row);
    }

    copyPrice() {
      const src = this.section.querySelector('.product-info__price');
      if (src) this.priceBox.innerHTML = src.innerHTML;
    }

    render() {
      const opts = this.currentOptions();
      const current = this.sizeIndex >= 0 ? opts[this.sizeIndex] : null;
      this.chips.forEach((c) => {
        const o = opts.slice();
        o[this.sizeIndex] = c.dataset.value;
        const v = this.variantFor(o);
        const out = !v || !v.a;
        c.classList.toggle('is-out', out);
        c.setAttribute('aria-label', out ? `${c.dataset.value}, sold out` : c.dataset.value);
        c.setAttribute('aria-pressed', String(this.picked && c.dataset.value === current));
      });
      const variant = this.variantFor(opts);
      const soldOut = this.picked && variant && !variant.a;
      this.addBtn.disabled = Boolean(soldOut) || (this.sizeIndex < 0 && variant && !variant.a);
      if (soldOut) this.say('This size is sold out. Try another size.');
      else if (this.picked) { this.say(''); this.classList.remove('is-asking'); }
      this.copyPrice();
      this.watchButton();
    }

    say(text) { this.msg.textContent = text; }

    pickSize(value) {
      const fs = this.sizeFieldset();
      const input = fs && [...fs.querySelectorAll('input')].find((i) => i.value === value);
      this.picked = true;
      if (input && !input.checked) {
        // noFocus: otherwise the picker focuses its own button after re-rendering and the page jumps down to it
        input.checked = true;
        input.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: { noFocus: true } }));
      } else this.render();
    }

    async add() {
      if (this.sizeIndex >= 0 && !this.picked) {
        this.classList.add('is-asking');
        this.say('Choose your size first.');
        this.chips.find((c) => !c.classList.contains('is-out'))?.focus();
        return;
      }
      const want = this.variantFor(this.currentOptions());
      if (!want || !want.a) { this.say('This size is sold out. Try another size.'); return; }
      // after a size change the theme re-renders the form; wait until it carries the chosen variant
      const idInput = () => this.section.querySelector('.js-product-form input[name="id"]');
      for (let i = 0; i < 30 && idInput() && String(idInput().value) !== String(want.id); i += 1) {
        await new Promise((r) => setTimeout(r, 100));
      }
      const btn = this.mainButton();
      if (!btn || btn.disabled) { this.say('This size is sold out. Try another size.'); return; }
      this.say('');
      btn.click();
    }

    openGuide() {
      const link = this.section.querySelector('.size-chart-link');
      if (link) link.click();
    }
  }
  customElements.define('md-buy-bar', MdBuyBar);
}
